<template>
	<div>
		<div class="card mb-4">
            <div class="card-header">
		    	<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Informações</strong>
		            </div>
			    </div>
		    </div>
		    <div class="card-body">
		    	<div class="container-fluid">
					<div class="text-muted fs-17 mb-2 ml-2">
				        <strong>Destino</strong>
				    </div>
					<div class="row">
						<div class="col-xl-6 col-md-6 mb-4">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Pedido</strong>
									</div>
									<div>
										{{ dados.pedido_id }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Cliente</strong>
									</div>
									<div>
										{{ dados.pedido.cliente }}
									</div>
								</li>
                                <li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Ordem</strong>
									</div>
									<div>
										{{ dados.ordem }}
									</div>
								</li>
							</ul>
						</div>
						<div class="col-xl-6 col-md-6 mb-4">
							<ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>CEP</strong>
									</div>
									<div>
										{{ dados.cep }}
									</div>
								</li>
                                <li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Estado</strong>
									</div>
									<div>
										{{ dados.estado }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Cidade</strong>
									</div>
									<div>
										{{ dados.cidade }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Bairro</strong>
									</div>
									<div>
										{{ dados.bairro }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Logradouro</strong>
									</div>
									<div>
										{{ dados.logradouro }}
									</div>
								</li>
                                <li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Complemento</strong>
									</div>
									<div>
										{{ dados.complemento }}
									</div>
								</li>
							</ul>
						</div>
					</div>
		    		<div class="row mt-4" v-if="dados.descricao">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Descrição</strong>
				            </div>
							<div class="card">
  								<div class="card-body" v-html="dados.descricao"></div>
							</div>
					    </div>
					</div>
				</div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados']
	}
</script>
